export default "__VITE_ASSET__oVovzsI7__"